import { render, staticRenderFns } from "./ViewDueDiligenceDialog.vue?vue&type=template&id=83d2bb16&scoped=true&"
import script from "./ViewDueDiligenceDialog.vue?vue&type=script&lang=js&"
export * from "./ViewDueDiligenceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ViewDueDiligenceDialog.vue?vue&type=style&index=0&id=83d2bb16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d2bb16",
  null
  
)

export default component.exports